import { get } from 'lodash';
import { createSelector } from 'reselect';
import { getVideoSectionAppSettingsPath, playbackSpeedValuesToProGalleryMap, playValuesToProGalleryMap, VIDEO_SETTINGS, VIDEO_SETTINGS_NAMES, } from '../../constants';
const { PLAY, PLAYBACK_SPEED, SOUND, LOOP, SHOW_PLAY_BUTTON } = VIDEO_SETTINGS_NAMES;
const getPlay = (state, section) => {
    const playIndex = get(state.appSettings, getVideoSectionAppSettingsPath(section, PLAY), VIDEO_SETTINGS[PLAY].defaultValue);
    return playValuesToProGalleryMap[playIndex];
};
const getPlaybackSpeed = (state, section) => {
    const playbackSpeedIndex = get(state.appSettings, getVideoSectionAppSettingsPath(section, PLAYBACK_SPEED), VIDEO_SETTINGS[PLAYBACK_SPEED].defaultValue);
    return playbackSpeedValuesToProGalleryMap[playbackSpeedIndex];
};
const getSound = (state, section) => get(state.appSettings, getVideoSectionAppSettingsPath(section, SOUND), VIDEO_SETTINGS[SOUND].defaultValue);
const getLoop = (state, section) => get(state.appSettings, getVideoSectionAppSettingsPath(section, LOOP), VIDEO_SETTINGS[LOOP].defaultValue);
const getShowPlayButton = (state, section) => get(state.appSettings, getVideoSectionAppSettingsPath(section, SHOW_PLAY_BUTTON), VIDEO_SETTINGS[SHOW_PLAY_BUTTON].defaultValue);
export const getVideoSettingsWithProGalleryValues = createSelector([getPlay, getPlaybackSpeed, getSound, getLoop, getShowPlayButton], (play, playbackSpeed, sound, loop, showPlayButton) => ({
    play,
    playbackSpeed,
    sound,
    loop,
    showPlayButton,
}));
//# sourceMappingURL=video-settings-selectors.js.map